var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({},'button',_vm.attrs,false),_vm.$listeners),[_vm._t("default",[(_vm.icon)?_c('span',{class:_vm.icon}):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }